import SelfAssessmentBase from 'es6/controllers/apps/quizzes/self-assessment-base';

class SelfAssessment extends SelfAssessmentBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('SelfAssessment');
    this._recallCue = this.itemPackage.getText();
    this.followUpQuiz = SelfAssessmentBinary;

    // Play audio on recall only if itemPackage is from a non-transliterated langauge.
    this._playAudioOnRecall = !this.itemPackage.getTransliteration();
  }
}

export class SelfAssessmentBinary extends SelfAssessment {
  constructor(...args) {
    super(...args);
    this._setQuizType('SelfAssessmentBinary');
    this._isRepeat = true;
  }
}

export default SelfAssessment;
